'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, domMax, LazyMotion, m, } from 'motion/react';
import { useEffect, useId, useMemo, } from 'react';
import { createPortal } from 'react-dom';
import styles from './overlay.module.css';
import { OverlayProvider } from './overlay-context.js';
export const Overlay = ({ children, root, theme = 'auto', index = 'auto', obfuscate = true, backdropOpacity = 0.7, onClose, }) => {
    const uid = useId();
    const defaultRoot = useMemo(() => (root ?? (typeof document !== 'undefined' ? document.body : null)), [root]);
    useEffect(() => {
        if (defaultRoot?.closest('[data-overlay]')) {
            throw new Error(`
        Overlay: An Overlay must not be inside another container.
        Please change the root prop.
      `);
        }
    }, [defaultRoot]);
    useEffect(() => {
        if (typeof document !== 'undefined') {
            if (children) {
                document.body?.setAttribute('data-overlay-open', 'true');
                document.body?.style.setProperty('--overlay-z-index', String(index));
            }
            else {
                document.body?.style.removeProperty('--overlay-z-index');
                document.body?.removeAttribute('data-overlay-open');
            }
        }
    }, [children, defaultRoot, index]);
    const content = (_jsx(OverlayProvider, { onClose: onClose, children: _jsx(AnimatePresence, { mode: "wait", children: children && (_jsx("div", { "data-overlay": true, "data-overlay-obfuscate": obfuscate, className: styles.Overlay, style: { zIndex: index }, children: _jsxs(LazyMotion, { features: domMax, children: [obfuscate && (_jsx(m.span, { className: styles.Backdrop, "data-overlay-color": theme, initial: { opacity: 0 }, animate: { opacity: backdropOpacity }, transition: { duration: 0.2 }, exit: { opacity: 0 } }, `${uid}-modal-backdrop`)), children] }) })) }) }));
    return defaultRoot && createPortal(content, defaultRoot);
};
